module.exports = __webpack_public_path__ + "img/cuff_length.d6243b19.png";